import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { CommunityGroups } from './communityGroups'

const WrappedCommunityGroups = withLayout(LayoutType.NoPadding, CommunityGroups)

export { WrappedCommunityGroups as CommunityGroups }
